import { render, staticRenderFns } from "./PurchasePopupTable.vue?vue&type=template&id=3c84bc40&scoped=true"
import script from "./PurchasePopupTable.vue?vue&type=script&lang=js"
export * from "./PurchasePopupTable.vue?vue&type=script&lang=js"
import style0 from "./PurchasePopupTable.vue?vue&type=style&index=0&id=3c84bc40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c84bc40",
  null
  
)

export default component.exports